/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import { addMonths } from 'date-fns/esm'
import getArchiveActions, {
    getArchiveTypes,
} from '../../../redux/demande/getArchive'
import { Get } from '../../../serveur/axios'

function* getArchiveSagas({ response }) {
    let { from, to } = response
    const { numIdentity, governorate } = response
    if (!from) {
        from = new Date()
    }
    if (!to) {
        to = addMonths(from, -6)
    }

    let url = `demande/archive/?date_debut=${from}&date_fin=${to}`

    if (numIdentity) {
        url = `${url}&numIdentity=${numIdentity}`
    }

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200) {
            yield all([
                yield put(getArchiveActions.getArchiveSuccess(res.data.data)),
            ])
        } else {
            yield put(getArchiveActions.getArchiveFailure(res.data.data))
        }
    } catch (error) {
        yield put(getArchiveActions.getArchiveFailure(error))
    }
}

export function* getArchiveSaga() {
    yield takeLatest(getArchiveTypes.GET_ARCHIVE_REQUEST, getArchiveSagas)
}
